import { render, staticRenderFns } from "./DPEvents.vue?vue&type=template&id=3ef0fa68&"
import script from "./DPEvents.vue?vue&type=script&lang=js&"
export * from "./DPEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports